import React from "react";
import {
  TextField,
  AutocompleteRenderGetTagProps,
  Autocomplete,
} from "@mui/material";
import { CustomFieldSchemaFragment, Option } from "__generated__/graphql";
import { OptionChip } from "../option/OptionChip";

interface ICustomMultiAutocompleteFieldProps {
  value: Option[] | null;
  setValue: (value: Option[] | null) => void;
  schema?: CustomFieldSchemaFragment | null;
  showLabel?: boolean;
  labelledById?: string;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  touched?: boolean;
}
export const CustomMultiAutocompleteField = ({
  value,
  setValue,
  schema,
  showLabel,
  labelledById,
  onKeyDown,
  errorMessage,
  touched,
}: ICustomMultiAutocompleteFieldProps) => {
  return (
    <Autocomplete
      multiple
      autoHighlight
      value={value ?? []}
      getOptionLabel={(option) => option.value}
      isOptionEqualToValue={(option, value) => option.value === value?.value}
      renderOption={(props, option: Option) => (
        <li {...props}>
          <OptionChip option={option} />
        </li>
      )}
      onChange={(e, value) =>
        setValue(
          value.map((option) => ({
            colour: option.colour,
            value: option.value,
            id: option.id,
          })),
        )
      }
      options={
        schema?.optionChoices?.map((option) => ({
          colour: option.colour,
          value: option.value,
          id: option.id,
        })) || []
      }
      renderTags={(
        options: Option[],
        getTagProps: AutocompleteRenderGetTagProps,
      ) =>
        options.map((option: Option, index: number) => (
          <OptionChip {...getTagProps({ index })} key={index} option={option} />
        ))
      }
      renderInput={(params) => (
        <>
          <TextField
            {...params}
            variant="outlined"
            size="small"
            placeholder={schema?.name}
            data-cy={schema?.name.replace(" ", "-")}
            label={showLabel && schema?.name}
            aria-labelledby={labelledById}
            onKeyDown={onKeyDown}
            error={touched && errorMessage ? true : false}
            helperText={errorMessage}
          />
        </>
      )}
    />
  );
};
